<template>
	<div class="one-click-listing-rule">
		<div class="page-info">
			<span class="info-tag">商品发布规则</span>
			商品发布规则配置，店铺：
			<span class="shop-name">{{ shopName }}</span>
		</div>

		<el-form ref="form" :model="form" :rules="rules" label-width="240px" class="config-form">
			<div class="section-block">
				<el-form-item label="自动配置商品_同步库存" prop="autoSyncStock">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.autoSyncStock" class="inline-radio-group">
							<el-radio label="sync">同步</el-radio>
							<el-radio label="no_sync">不同步</el-radio>
						</el-radio-group>
						<p class="field-tip">新商品上架时自动配置商品同步库存状态</p>
					</div>
				</el-form-item>
				<el-form-item label="自动配置商品_库存规则" prop="stockRule">
					<div class="field-row field-row--wide">
						<el-select v-model="form.stockRule" placeholder="请选择">
							<el-option
								v-for="item in stockRuleOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
						<p class="field-tip">新商品上架时自动采用配置的规则</p>
					</div>
				</el-form-item>
				<el-form-item label="首张主图" prop="mainImageType">
					<div class="field-row">
						<el-radio-group v-model="form.mainImageType" class="inline-radio-group inline-radio-group--wrap">
							<el-radio label="store">专卖店款</el-radio>
							<el-radio label="ai">AI主图</el-radio>
							<el-radio label="store_ai">专卖店款+AI主图</el-radio>
						</el-radio-group>
						<p class="field-tip">推荐使用专卖店款+AI主图；拼多多展示首张主图</p>
					</div>
				</el-form-item>
				<el-form-item label="商品属性_品牌" prop="brandType">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.brandType" class="inline-radio-group">
							<el-radio label="none">无品牌</el-radio>
							<el-radio label="add">加品牌</el-radio>
						</el-radio-group>
						<p class="field-tip">加品牌需有品牌权限，否则可能被驳回</p>
					</div>
				</el-form-item>
				<el-form-item label="拼单人数 (不小于2人)" prop="groupBuyCount">
					<div class="field-row">
						<el-input-number v-model="form.groupBuyCount" :min="2" :max="2" :controls="false" disabled />
						<p class="field-tip">暂定为 2 人，不可修改</p>
					</div>
				</el-form-item>
				<el-form-item label="预售类型" prop="presaleType">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.presaleType" class="inline-radio-group">
							<el-radio label="none">非预售</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item label="承诺发货时间 (小时)" prop="deliveryHours">
					<div class="field-row">
						<el-radio-group v-model="form.deliveryHours" class="inline-radio-group">
							<el-radio :label="48">48小时</el-radio>
							<el-radio :label="24">24小时</el-radio>
							<el-radio :label="0">当日发货</el-radio>
						</el-radio-group>
						<p class="field-tip">非预售最长 48 小时；预售类型不同可承诺时间不同</p>
					</div>
				</el-form-item>
				<el-form-item label="是否支持正品发票" prop="invoiceSupport">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.invoiceSupport" class="inline-radio-group">
							<el-radio label="no">不支持</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item label="是否支持假一赔十" prop="fakeRefund">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.fakeRefund" class="inline-radio-group">
							<el-radio label="yes">支持</el-radio>
							<el-radio label="no">不支持</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item label="是否7天无理由退换货" prop="sevenDayReturn">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.sevenDayReturn" class="inline-radio-group">
							<el-radio label="yes">支持</el-radio>
							<el-radio label="no">不支持</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item label="是否二手商品" prop="secondHand">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.secondHand" class="inline-radio-group">
							<el-radio label="new">全新商品</el-radio>
							<el-radio label="used">二手商品</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
			</div>

			<div class="section-block">
				<el-form-item label="满2件折扣" prop="twoItemDiscount">
					<div class="field-row">
						<el-select v-model="form.twoItemDiscount" placeholder="请选择">
							<el-option
								v-for="item in discountOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item label="拼单价减价 (元)" prop="groupPriceReduce">
					<div class="field-row">
						<el-input-number v-model="form.groupPriceReduce" :precision="0" :min="0" :controls="false" />
						<p class="field-tip">默认为 1 元。公式：拼单价 = 单独价 - 拼单价减价</p>
					</div>
				</el-form-item>
				<el-form-item label="运费模板" prop="freightTemplate">
					<div class="field-row field-row--wide">
						<el-select v-model="form.freightTemplate" placeholder="请选择" filterable>
							<el-option
								v-for="item in freightTemplateOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
					</div>
				</el-form-item>

				<div class="freight-detail">
					<div class="freight-detail__title">运费模板详情</div>
					<div class="freight-detail__row">
						<span class="freight-detail__label">包邮省份</span>
						<span class="freight-detail__value freight-detail__value--primary">{{ currentFreight.freeProvinces }}</span>
					</div>
					<div class="freight-detail__row">
						<span class="freight-detail__label">不包邮省份</span>
						<span class="freight-detail__value freight-detail__value--primary">{{ currentFreight.paidProvinces }}</span>
					</div>
					<div class="freight-detail__row">
						<span class="freight-detail__label">不配送省份</span>
						<span class="freight-detail__value freight-detail__value--primary">{{ currentFreight.noDeliveryProvinces }}</span>
					</div>
				</div>

				<el-form-item label="更新商品时不更新哪些字段" prop="skipUpdateFields">
					<div class="field-row">
						<el-checkbox-group v-model="form.skipUpdateFields">
							<el-checkbox label="title">标题</el-checkbox>
							<el-checkbox label="mainImage">主图</el-checkbox>
						</el-checkbox-group>
					</div>
				</el-form-item>
			</div>

			<div class="section-block section-block--table">
				<p class="section-note">上架款式排序，优先使用哪个款型；若排第 1 位的款型没有相应图片集，则使用第 2 位，依次类推</p>
				<el-table :data="form.styleSortList" class="style-table" border>
					<el-table-column prop="styleName" label="款型" min-width="160" />
					<el-table-column label="状态" width="120" align="center">
						<template slot-scope="scope">
							<span
								class="status-tag"
								:class="{ 'status-tag--on': scope.row.enabled }"
								@click="toggleStyleEnabled(scope.$index)"
							>
								<i v-if="scope.row.enabled" class="el-icon-check" />
								{{ scope.row.enabled ? '启用' : '禁用' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="排序号" width="140" align="center">
						<template slot-scope="scope">
							<el-input-number
								v-model="scope.row.sortNo"
								:min="1"
								:precision="0"
								:controls="false"
								size="small"
								class="sort-input"
							/>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div class="form-actions">
				<el-button type="primary" @click="onSave">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
const NO_DELIVERY_HK_MO_TW = '香港特别行政区、澳门特别行政区、台湾省'

const FREE_MAINLAND = '北京市、安徽省、福建省、甘肃省、广东省、广西壮族自治区、贵州省、海南省、河北省、河南省、黑龙江省、湖北省、湖南省、吉林省、江苏省、江西省、辽宁省、内蒙古自治区、宁夏回族自治区、青海省、山东省、山西省、陕西省、上海市、四川省、天津市、云南省、浙江省、重庆市'

const FREE_MAINLAND_WITH_XJ_XZ = `${FREE_MAINLAND}、西藏自治区、新疆维吾尔自治区`

const TIBET_XINJIANG = '西藏自治区、新疆维吾尔自治区'

const FREE_REMOTE_CHARGE = '北京市、安徽省、福建省、广东省、广西壮族自治区、贵州省、海南省、河北省、河南省、黑龙江省、湖北省、湖南省、吉林省、江苏省、江西省、辽宁省、山东省、山西省、陕西省、上海市、四川省、天津市、云南省、浙江省、重庆市'

const PAID_REMOTE = '甘肃省、内蒙古自治区、宁夏回族自治区、青海省、西藏自治区、新疆维吾尔自治区'

const FREE_WITHOUT_NM_XJ_XZ = '北京市、安徽省、福建省、甘肃省、广东省、广西壮族自治区、贵州省、海南省、河北省、河南省、黑龙江省、湖北省、湖南省、吉林省、江苏省、江西省、辽宁省、宁夏回族自治区、青海省、山东省、山西省、陕西省、上海市、四川省、天津市、云南省、浙江省、重庆市'

const PAID_NM_XJ_XZ = '内蒙古自治区、西藏自治区、新疆维吾尔自治区'

const freightTemplateMap = {
	mainland_free: {
		freeProvinces: FREE_MAINLAND_WITH_XJ_XZ,
		paidProvinces: '无',
		noDeliveryProvinces: NO_DELIVERY_HK_MO_TW,
	},
	default_xj_xz: {
		freeProvinces: FREE_MAINLAND,
		paidProvinces: '无',
		noDeliveryProvinces: `${TIBET_XINJIANG}、${NO_DELIVERY_HK_MO_TW}`,
	},
	xj_xz_paid: {
		freeProvinces: FREE_MAINLAND,
		paidProvinces: TIBET_XINJIANG,
		noDeliveryProvinces: NO_DELIVERY_HK_MO_TW,
	},
	free_20240601060757: {
		freeProvinces: FREE_MAINLAND_WITH_XJ_XZ,
		paidProvinces: '无',
		noDeliveryProvinces: NO_DELIVERY_HK_MO_TW,
	},
	remote_per_item: {
		freeProvinces: FREE_REMOTE_CHARGE,
		paidProvinces: PAID_REMOTE,
		noDeliveryProvinces: NO_DELIVERY_HK_MO_TW,
	},
	default_20240909: {
		freeProvinces: FREE_MAINLAND,
		paidProvinces: TIBET_XINJIANG,
		noDeliveryProvinces: NO_DELIVERY_HK_MO_TW,
	},
	default_20240731: {
		freeProvinces: FREE_WITHOUT_NM_XJ_XZ,
		paidProvinces: PAID_NM_XJ_XZ,
		noDeliveryProvinces: NO_DELIVERY_HK_MO_TW,
	},
}

const freightTemplateOptions = [
	{ value: 'mainland_free', label: '内地包邮默认模板' },
	{ value: 'default_xj_xz', label: '新疆西藏不配送默认模板' },
	{ value: 'xj_xz_paid', label: '新疆西藏收费默认模板' },
	{ value: 'free_20240601060757', label: '包邮默认模板-20240601060757' },
	{ value: 'remote_per_item', label: '偏远按件收费默认模板' },
	{ value: 'default_20240909', label: '默认2024-09-09-12:10:40.31710' },
	{ value: 'default_20240731', label: '默认2024-07-31-17:27:25.886791' },
]

const createDiscountOptions = () =>
	Array.from({ length: 51 }, (_, i) => {
		const v = (50 + i) / 10
		return {
			value: v,
			label: v === 10 ? '10折(不打折)' : `${v}折`,
		}
	})

export default {
	name: 'OneClickListingRule',
	data() {
		return {
			shopName: '驰方户外运动专营店',
			form: {
				autoSyncStock: 'sync',
				stockRule: 'safety_stock_price',
				mainImageType: 'store',
				brandType: 'add',
				groupBuyCount: 2,
				presaleType: 'none',
				deliveryHours: 48,
				invoiceSupport: 'no',
				fakeRefund: 'yes',
				sevenDayReturn: 'yes',
				secondHand: 'new',
				twoItemDiscount: 9.9,
				groupPriceReduce: 1,
				freightTemplate: 'default_xj_xz',
				skipUpdateFields: [],
				styleSortList: [
					{ styleName: '专卖店款', enabled: true, sortNo: 1 },
					{ styleName: '白底款', enabled: true, sortNo: 2 },
				],
			},
			rules: {
				autoSyncStock: [{ required: true, message: '请选择', trigger: 'change' }],
				stockRule: [{ required: true, message: '请选择', trigger: 'change' }],
				mainImageType: [{ required: true, message: '请选择', trigger: 'change' }],
				brandType: [{ required: true, message: '请选择', trigger: 'change' }],
				groupBuyCount: [{ required: true, message: '请填写', trigger: 'blur' }],
				presaleType: [{ required: true, message: '请选择', trigger: 'change' }],
				deliveryHours: [{ required: true, message: '请选择', trigger: 'change' }],
				invoiceSupport: [{ required: true, message: '请选择', trigger: 'change' }],
				fakeRefund: [{ required: true, message: '请选择', trigger: 'change' }],
				sevenDayReturn: [{ required: true, message: '请选择', trigger: 'change' }],
				secondHand: [{ required: true, message: '请选择', trigger: 'change' }],
				twoItemDiscount: [{ required: true, message: '请选择', trigger: 'change' }],
				groupPriceReduce: [{ required: true, message: '请填写', trigger: 'blur' }],
				freightTemplate: [{ required: true, message: '请选择', trigger: 'change' }],
			},
			stockRuleOptions: [
				{ value: 'safety_stock_price', label: '通用安全库存规则改价格' },
				{ value: 'fixed_price_channel', label: '一口价选渠道-通用规则' },
				{ value: 'manual_assign', label: '手工指定-通用规则' },
			],
			discountOptions: createDiscountOptions(),
			freightTemplateOptions,
			freightTemplateMap,
		}
	},
	computed: {
		currentFreight() {
			return this.freightTemplateMap[this.form.freightTemplate] || {
				freeProvinces: '-',
				paidProvinces: '-',
				noDeliveryProvinces: '-',
			}
		},
	},
	methods: {
		toggleStyleEnabled(index) {
			this.form.styleSortList[index].enabled = !this.form.styleSortList[index].enabled
		},
		onSave() {
			this.$refs.form.validate((valid) => {
				if (!valid) return
				this.$message.success('保存成功')
			})
		},
	},
}
</script>

<style scoped lang="less">
.one-click-listing-rule {
	padding: 24px 28px 40px;
	background: #fff;
	min-height: 100%;
	box-sizing: border-box;
}

.page-info {
	margin-bottom: 24px;
	padding: 14px 18px;
	font-size: 14px;
	line-height: 1.6;
	color: #606266;
	background: #fafbfc;
	border-left: 3px solid #67c23a;
	border-radius: 0 6px 6px 0;

	.info-tag {
		display: inline-block;
		margin-right: 8px;
		padding: 2px 10px;
		font-size: 12px;
		color: #409eff;
		background: rgba(64, 158, 255, 0.08);
		border-radius: 3px;
		vertical-align: middle;
	}

	.shop-name {
		color: #ff4714;
		font-weight: 500;
	}
}

.config-form {
	max-width: 100%;

	/deep/ .el-form-item {
		margin-bottom: 18px;
	}

	/deep/ .el-form-item__label {
		font-size: 12px;
		color: #606266;
		line-height: 36px;
		padding-right: 16px;
	}

	/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
		color: #f56c6c;
	}
}

.section-block {
	margin-bottom: 24px;
	padding: 20px 20px 8px;
	background: #fafbfc;
	border: 1px solid #f0f2f5;
	border-radius: 6px;

	&--table {
		padding-bottom: 20px;
	}
}

.field-row {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 16px;
	max-width: 100%;

	.el-input,
	.el-select,
	.el-input-number {
		width: 280px;
		flex-shrink: 0;
	}

	&--wide .el-select {
		width: 520px;
		max-width: 100%;
	}

	&--radio {
		align-items: center;

		.field-tip {
			margin: 0;
			padding-top: 0;
		}
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}

	/deep/ .el-input__inner {
		height: 36px;
		line-height: 36px;
		border-color: #e8eaed;
		border-radius: 4px;
		background: #fff;
		transition: all 0.2s;

		&:hover {
			border-color: #dcdfe6;
		}

		&:focus {
			border-color: #ff4714;
		}
	}

	/deep/ .el-checkbox {
		margin-right: 24px;
		line-height: 36px;
	}
}

.field-tip {
	flex: 1;
	min-width: 240px;
	margin: 10px 0 0;
	padding-top: 2px;
	font-size: 11px;
	color: #b0b3b8;
	line-height: 1.6;
}

.inline-radio-group {
	flex-shrink: 0;
	display: inline-flex;
	flex-wrap: nowrap;
	align-items: center;
	min-height: 36px;

	&--wrap {
		flex-wrap: wrap;
		gap: 4px 0;
	}

	/deep/ .el-radio {
		display: inline-flex;
		align-items: center;
		margin-right: 24px;
		line-height: 1;

		&:last-child {
			margin-right: 0;
		}
	}

	/deep/ .el-radio__label {
		font-size: 14px;
		line-height: 1;
		padding-left: 8px;
	}
}

.freight-detail {
	margin: 0 0 20px;
	padding: 16px 18px;
	background: #fff;
	border: 1px solid #eef0f3;
	border-radius: 6px;

	&__title {
		margin-bottom: 12px;
		font-size: 14px;
		font-weight: 500;
		color: #303133;
	}

	&__row {
		display: flex;
		align-items: flex-start;
		padding: 8px 0;
		font-size: 12px;
		line-height: 1.7;
		border-bottom: 1px solid #f5f6f8;

		&:last-child {
			border-bottom: none;
		}
	}

	&__label {
		flex-shrink: 0;
		width: 96px;
		color: #409eff;
		font-weight: 500;
	}

	&__value {
		flex: 1;
		color: #303133;
		word-break: break-all;

		&--primary {
			color: #303133;
		}
	}
}

.section-note {
	margin: 0 0 16px;
	font-size: 13px;
	color: #909399;
	line-height: 1.6;
}

.style-table {
	width: 100%;
	background: #fff;

	/deep/ th {
		background: #fafbfc;
		color: #909399;
		font-weight: 500;
	}

	/deep/ td,
	/deep/ th {
		border-color: #f0f2f5;
	}
}

.status-tag {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	min-width: 64px;
	padding: 4px 12px;
	font-size: 12px;
	color: #909399;
	background: #f5f6f8;
	border-radius: 4px;
	cursor: pointer;
	user-select: none;
	transition: all 0.2s;

	&--on {
		color: #fff;
		background: #67c23a;
	}

	i {
		font-size: 12px;
		font-weight: bold;
	}
}

.sort-input {
	width: 80px;

	/deep/ .el-input__inner {
		text-align: center;
	}
}

.form-actions {
	display: flex;
	justify-content: center;
	margin-top: 8px;
	padding-top: 24px;

	.el-button {
		min-width: 120px;
		height: 36px;
		padding: 0 32px;
		font-size: 12px;
		border-radius: 4px;
		letter-spacing: 2px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/oneClickListingRule.vue